<template>
  <section class="slide-2 flex flex-col overflow-hidden">
    <div class="header flex justify-between items-center mx-4.5 mb-7.5">
      <p
        class="fz-10 font-medium color-gray uppercase"
        style="line-height: 1; letter-spacing: 0.3rem"
      >
        {{ text.miniTitle }}
      </p>
      <div class="flex icons">
        <svg
          class="mr-6"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-opacity="0.3"
            d="M28.3333 35V31.6667C28.3333 29.8986 27.631 28.2029 26.3807 26.9526C25.1305 25.7024 23.4348 25 21.6667 25H8.33334C6.56523 25 4.86954 25.7024 3.61929 26.9526C2.36905 28.2029 1.66667 29.8986 1.66667 31.6667V35"
            stroke="#97A3CB"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            stroke-opacity="0.3"
            d="M15 18.3333C18.6819 18.3333 21.6667 15.3486 21.6667 11.6667C21.6667 7.98477 18.6819 5 15 5C11.3181 5 8.33334 7.98477 8.33334 11.6667C8.33334 15.3486 11.3181 18.3333 15 18.3333Z"
            stroke="#97A3CB"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            stroke-opacity="0.3"
            d="M38.3333 35V31.6667C38.3322 30.1896 37.8406 28.7546 36.9356 27.5872C36.0306 26.4198 34.7636 25.586 33.3333 25.2167"
            stroke="#97A3CB"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            stroke-opacity="0.3"
            d="M26.6667 5.21667C28.1007 5.58384 29.3717 6.41784 30.2794 7.58719C31.1871 8.75654 31.6797 10.1947 31.6797 11.675C31.6797 13.1553 31.1871 14.5935 30.2794 15.7628C29.3717 16.9322 28.1007 17.7662 26.6667 18.1333"
            stroke="#97A3CB"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <svg
          width="32"
          height="36"
          viewBox="0 0 32 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-opacity="0.3"
            d="M17.6667 1.33333L1 21.3333H16L14.3333 34.6667L31 14.6667H16L17.6667 1.33333Z"
            stroke="#97A3CB"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
    <p class="fz-16 font-medium mb-25 mx-4.5" style="line-height: 1.875">
      {{ text.mainText }}
    </p>
    <span
      class="fz-10 ml-4.5 font-medium color-accent mb-7.5 uppercase"
      style="line-height: 1; letter-spacing: 0.3rem"
      >{{ text.ready }}</span
    >
    <slider
      :slides-container-classes="'pl-4.5 mb-5 gap-7.5'"
      :slider-classes="''"
      :similar-slides="true"
      :pagination="true"
      pagination-container-classes="gap-5 pl-4.5"
    >
      <template v-slot:slides>
        <div
          class="slider-slide w-62.5 flex flex-col"
          v-for="item in text.stackSlider"
          :key="item"
        >
          <img
            :src="
              require('@/assets/images/slide_2/stack/' + item.image + '.svg')
            "
            class="h-19 w-19 p-4.5 rounded-full mb-5"
            style="background: rgba(110, 117, 141, 0.2)"
            alt=""
          />
          <p class="fz-16 font-medium" style="line-height: 1.5625rem">
            {{ item.text }}
          </p>
        </div>
      </template>
      <template v-slot:pagination>
        <div class="w-1.25 h-1.25 rounded-full bg-white"></div>
      </template>
    </slider>
  </section>
</template>

<script>
import slider from "@/components/mobile/reuseable/slider";
import {mapState} from "vuex";

export default {
  name: "slide2",
  computed: {
    text() {
      return require("@/assets/text/main/slide2/" + this.lang + ".json");
    },
    ...mapState(['lang'])
  },
  components: {
    slider,
  },
};
</script>

<style scoped lang="scss">
.slide-2 {
  .header {
    .icons {
      svg {
        width: 2.5rem;
      }
    }
  }
}

.pagination {
  transition: all linear 0.3s;
  background: #fff;
}
.pagination > div > * {
  transition: all linear 0.3s;
}
.pagination .active {
  width: 2.5rem;
  height: 0.25rem;
  background: rgba(255, 46, 83, 1);
}
</style>
